// Small enhancements; report navigation and date filtering also work without JS.
export function startAnalyticsUi() {
  const page = document.querySelector("[data-analytics-page]");
  if (!page) return;
  const period = page.querySelector("[data-analytics-period]");
  const customDates = page.querySelector("[data-analytics-custom]");
  if (period && customDates) {
    const sync = () => {
      customDates.hidden = period.value !== "custom";
      for (const input of customDates.querySelectorAll("input")) input.disabled = customDates.hidden;
    };
    period.addEventListener("change", sync);
    sync();
  }
  const filters = page.querySelector("[data-location-filters]");
  if (!filters) return;
  const search = filters.querySelector("[data-location-search]");
  const active = filters.querySelector("[data-location-active]");
  const count = filters.querySelector("[data-location-count]");
  const empty = page.querySelector("[data-location-empty]");
  const normalize = (text) => text.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
  const rows = [...page.querySelectorAll("[data-location-row]")].map((row) => ({ row, search: normalize(row.dataset.search || "") }));
  const filter = () => {
    const query = normalize(search.value.trim());
    let visible = 0;
    for (const entry of rows) {
      entry.row.hidden = !entry.search.includes(query) || (active.checked && entry.row.dataset.active !== "1");
      if (!entry.row.hidden) visible++;
    }
    count.textContent = `${visible} of ${rows.length} locations`;
    empty.hidden = visible !== 0;
  };
  filters.hidden = false;
  filters.addEventListener("submit", (event) => event.preventDefault());
  search.addEventListener("input", filter);
  active.addEventListener("change", filter);
  filter();
}
